import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Navbar from "./components/Navbar";
import { LandsProvider } from "./context/LandsContext";
import LandsSection from "./components/LandsSection";
import LandDetails from "./pages/LandDetails";
import NotFound from "./components/Shared/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandsSection />,
    errorElement: <NotFound />,
  },
  {
    path: "/details/:id",
    element: <LandDetails />,
    errorElement: <NotFound />,
  },
]);

function App() {
  return (
    <LandsProvider>
      <Navbar />
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </LandsProvider>
  );
}

export default App;
